// extracted by css-extract-rspack-plugin
export default {"itemRoot":"oI8bs2","itemLink":"GYTRFQ"};